import { VueConstructor } from "vue";
import Vue from "vue";
import BannerPWA from "@/views/PageMore/components/BannerPWA";
import MoreMenuItemCallsToggle from "@/views/PageMore/components/MoreMenuItem/Integration/MoreMenuItemCallsToggle";
import MoreMenuItemDefault from "@/views/PageMore/components/MoreMenuItem/Integration/MoreMenuItemDefault";
import MoreMenuItemSeparator from "@/views/PageMore/components/MoreMenuItem/Integration/MoreMenuItemSeparator";
import MoreMenuProfileInfo from "@/views/PageMore/components/MoreMenuProfileInfo";
import { IMoreMenuItem, MENU_MODULES } from "@/views/PageMore/config";

export function getMoreMenuItem(item: IMoreMenuItem): VueConstructor<Vue> {
  switch (item.name) {
    case MENU_MODULES.PWA_BANNER:
      return BannerPWA;
    case MENU_MODULES.PROFILE_INFO:
      return MoreMenuProfileInfo;
    case MENU_MODULES.SEPARATOR:
      return MoreMenuItemSeparator;
    case MENU_MODULES.CALLS_TOGGLE:
      return MoreMenuItemCallsToggle;
    default:
      return MoreMenuItemDefault;
  }
}
